import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c297fd4e&scoped=true"
import script from "./header.js?vue&type=script&lang=js&external"
export * from "./header.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=c297fd4e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c297fd4e",
  null
  
)

export default component.exports